/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */



import React from 'react'
import {Modal} from 'react-bootstrap'
import "./popupVid.scss"

export default function popupVid(props) {
  return (
    <Modal dialogClassName="mn-modal-video" show={props.modalIsShow} onHide={props.hideModal}>
        <Modal.Header closeButton>
            <Modal.Title>Course video</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <iframe style={{width:800, height:500}}
                src="https://www.youtube.com/embed/dQw4w9WgXcQ">
            </iframe>
        </Modal.Body>
    </Modal>
  )
}
